import {
  COUNTRIES_KEY,
  CURRENCIES_KEY,
  DROPDOWN_ITEMS_KEY,
  INSTANCE_CONFIG_KEY,
} from '../../../utils/constants/queryKeys';
import { Country, IInstanceConfig, State } from '../../types/Common';
import { createApiFetcher } from 'src/utils/ApiUtils';

const fetchData = createApiFetcher('common/');

export const getDropdownItems = (type: string): Promise<{ id: number; type: string }[]> =>
  fetchData(DROPDOWN_ITEMS_KEY, { type });

export const getCountries = (): Promise<Country[]> => fetchData<Country[]>(COUNTRIES_KEY);

export const getStates = (countryCode: string): Promise<State[]> => fetchData('states', { countryCode });

export const getCounties = (state: string) => fetchData<string[]>('counties', { state });

export const getCurrencies = (): Promise<string[]> => fetchData<string[]>(CURRENCIES_KEY);

export const getInstanceConfig = (): Promise<IInstanceConfig> => fetchData<IInstanceConfig>(INSTANCE_CONFIG_KEY);
